"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { Suspense } from "react";

function TagFilterInner({
  allTags,
}: {
  allTags: { tag: string; count: number }[];
}) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const activeTags = searchParams.get("tag")?.split(",").filter(Boolean) || [];

  function toggleTag(tag: string) {
    const next = activeTags.includes(tag)
      ? activeTags.filter((t) => t !== tag)
      : [...activeTags, tag];

    const params = new URLSearchParams();
    if (next.length > 0) params.set("tag", next.join(","));
    router.push(`/blog${next.length > 0 ? `?${params}` : ""}`);
  }

  return (
    <div className="flex flex-wrap gap-2 mb-8">
      {allTags.map(({ tag, count }) => {
        const active = activeTags.includes(tag);
        return (
          <button
            key={tag}
            onClick={() => toggleTag(tag)}
            className={`px-3 py-1.5 rounded-full text-sm border transition-colors ${
              active
                ? "bg-accent text-white border-accent"
                : "bg-white text-foreground border-border hover:border-accent"
            }`}
          >
            {tag}
            <span className="ml-1 text-xs opacity-60">{count}</span>
          </button>
        );
      })}
    </div>
  );
}

export function TagFilter({
  allTags,
}: {
  allTags: { tag: string; count: number }[];
}) {
  return (
    <Suspense fallback={<div className="h-10 mb-8" />}>
      <TagFilterInner allTags={allTags} />
    </Suspense>
  );
}
